import style from './Icon.module.scss';

import { IconType, IconTypeToComponentMap } from './IconType';

interface IconProps {
    type: IconType;
}

/** @deprecated Import SVG files directly. This enables code splitting and unused SVG elimination. */
export function Icon({ type }: IconProps) {
    const Component = IconTypeToComponentMap[type];

    return <Component className={style.root} />;
}
